<template>
  <v-navigation-drawer floating v-model="tab" v-if="tab != null" class="offset-plotreport">
    <v-card class="d-flex flex-column ma-0 pa-0" flat v-if="plotItem">
      <!-- Tabs and Close Button in one row -->
      <div class="d-flex flex-row align-center px-2 pt-3 pb-1 tab-header-row">
        <v-tabs v-model="activeTab" background-color="transparent" class="tabs-left flex-grow-1" grow height="40">
          <v-tab key="reports">
            <v-icon left>mdi-file-document-outline</v-icon>
            Reports
          </v-tab>
          <v-tab key="downloads">
            <v-icon left>mdi-robot</v-icon>
            Downloads
          </v-tab>
          <v-tab key="aimode">
            <v-icon left>mdi-robot</v-icon>
            AI Chat
          </v-tab>
        </v-tabs>
        <v-btn fab elevation="0" class="red--text ml-2" x-small @click="clearClickView">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <!-- Reports / AI Chat Tabs -->
      <v-tabs-items v-model="activeTab" class="flex-grow-1 d-flex flex-column">
        <!-- Reports Tab -->
        <v-tab-item :value="0">
          <v-list two-line class="report-list">
            <v-list-item @click="fullReportPDF(plotItem)" class="report-item">
              <v-list-item-avatar>
                <v-icon large>mdi-file-pdf-box</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">{{ $t("full-report") }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click.stop="fullReportPDF(plotItem)"><v-icon>mdi-open-in-new</v-icon></v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-list-item @click="openBaureglement" class="report-item">
              <v-list-item-avatar>
                <v-icon large>mdi-city</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">{{ $t("baureglement") }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click.stop="openBaureglement"><v-icon>mdi-open-in-new</v-icon></v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-list-item @click="openSolarPotential" class="report-item">
              <v-list-item-avatar>
                <v-icon large>mdi-weather-sunny</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">{{ $t("solar-potential") }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click.stop="openSolarPotential"><v-icon>mdi-open-in-new</v-icon></v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-list-item @click="open3dElevation" class="report-item">
              <v-list-item-avatar>
                <v-icon large>mdi-cloud</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">{{ $t("ed-elevation") }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click.stop="open3dElevation"><v-icon>mdi-open-in-new</v-icon></v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-tab-item>
        <v-tab-item :value="1">
          <v-list two-line class="report-list">
            <v-list-item @click="openOREB" class="report-item">
              <v-list-item-avatar>
                <v-icon large>mdi-earth</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">{{ $t("oreb") }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click.stop="openOREB"><v-icon>mdi-open-in-new</v-icon></v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-list-item @click="openDFX" class="report-item">
              <v-list-item-avatar>
                <v-icon large>mdi-plus</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">{{ $t("dxf") }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click.stop="openDFX"><v-icon>mdi-open-in-new</v-icon></v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-list-item @click="openDWG" class="report-item">
              <v-list-item-avatar>
                <v-icon large>mdi-autorenew</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">{{ $t("dwg") }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click.stop="openDWG"><v-icon>mdi-open-in-new</v-icon></v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-list-item @click="openIFC" class="report-item">
              <v-list-item-avatar>
                <v-icon large>mdi-file-cad</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">{{ $t("ifc") }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click.stop="openIFC"><v-icon>mdi-open-in-new</v-icon></v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-tab-item>

        <!-- AI Chat Tab -->
        <v-tab-item :value="2" v-if="profile">
          <!-- Reworked chat wrapper -->
          <Chat :plotItem="plotItem"></Chat>
        </v-tab-item>
      </v-tabs-items>
      <!-- End Tabs -->
    </v-card>
  </v-navigation-drawer>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from "vue-property-decorator"
import {searchService} from "./service"
import Chat from "./Chat.vue"
import {config, utils} from "@/libs/utils"

@Component({
  components: {Chat},
})
export default class ViewPlotReport extends Vue {
  plotPrefix = config.VUE_APP_PLOT_NUMBER_PREFIX

  @Prop()
  tab

  @Prop()
  plotItem

  @Prop()
  objectItems

  @Prop()
  canton

  tabViewObject = -1
  tabViewDetails = 0
  objectSelected = null

  lang

  data: any = {
    items: [],
    plotItemViewActive: false,
  }

  profile

  contentJson: any = {}

  // New UI state
  activeTab: number | string = 0

  constructor() {
    super()
    this.profile = this.$store.getters.profile
    this.lang = this.$i18n.locale || localStorage.getItem("user-language")

    // console.log("TabViewReport created, plotItem:", this.tab)
    let btn = this.tab?.btn
    if (btn == "reports") {
      this.activeTab = 0
    } else if (btn == "downloads") {
      this.activeTab = 1
    } else if (btn == "aimode") {
      this.activeTab = 2
    } else {
      this.activeTab = 0
    }
  }

  created() {
    this.loadTooltip()
  }

  @Watch("tab")
  onTabChange(val) {
    // console.log("TabViewReport tab changed:", val)
    let btn = val?.btn
    if (btn == "reports") {
      this.activeTab = 0
    } else if (btn == "downloads") {
      this.activeTab = 1
    } else if (btn == "aimode") {
      this.activeTab = 2
    } else {
      this.activeTab = 0
    }
  }

  async loadTooltip() {
    this.contentJson = (await this.$store.dispatch("tooltip/getTooltipContent", "section200")) || {}
  }

  @Watch("tabViewObject")
  async onTabViewObjectChange(val) {
    if (val >= 0) {
      let obj = this.objectItems[val]
      this.$emit("onObjectItemClicked", obj)
      this.objectSelected = obj
    }
  }

  @Watch("plotItem")
  async onPlotItemChange(val) {
    this.tabViewObject = -1
    if (val) {
      this.data.plotItemViewActive = true
    } else {
      this.data.plotItemViewActive = false
    }
  }
  async clearClickView() {
    this.$emit("onClearClickView")
  }

  // New handler to unify click behavior for list items and action buttons
  handleReportClick(r: any) {
    if (!r) return
    // prefer action if provided
    if (r.action && typeof (this as any)[r.action] === "function") {
      ;(this as any)[r.action](this.plotItem)
      return
    }
    // open provided url
    if (r.url) {
      window.open(r.url, "_blank")
      return
    }
    // fallback: if title looks like a url
    if (r.title && typeof r.title === "string" && r.title.startsWith("http")) {
      window.open(r.title, "_blank")
    }
  }

  async openReport(r: {url: string; type: string}) {
    if (r && r.type) {
      const baseUrl = config.VUE_APP_REPORTS_URL || ""
      let oneTimeToken = await searchService.getReportDownloadOneTimeToken(this.plotItem.PRC_ID)
      window.open(`${baseUrl}/v1/secure/user/download/${r.type}?id=${this.plotItem.PRC_ID}&lang=${this.lang}&ott_token=${oneTimeToken.token}`, "_blank")
    } else if (r && r.url) {
      window.open(r.url, "_blank")
    }
  }

  openOREB() {
    if (this.canton?.urlOREB) {
      window.open(this.canton.urlOREB + this.plotItem.PRC_ID, "_blank")
    }
  }
  openDFX() {
    window.open("https://dxf.terrara.ch/dxf/dxf.php?id=" + this.plotItem.PRC_ID + "&lang=" + this.lang + "&canton=" + this.plotItem.CANTON, "_blank")
  }
  openDWG() {
    window.open("https://dwg.terrara.ch/dwg/dwg.php?id=" + this.plotItem.PRC_ID + "&lang=" + this.lang + "&canton=" + this.plotItem.CANTON, "_blank")
  }
  openIFC() {
    window.open("https://ifc.terrara.ch/ifc/ifc.php?id=" + this.plotItem.PRC_ID + "&lang=" + this.lang + "&canton=" + this.plotItem.CANTON, "_blank")
  }
  async openBaureglement() {
    const baseUrl = config.VUE_APP_REPORTS_URL || ""
    let oneTimeToken = await searchService.getReportDownloadOneTimeToken(this.plotItem.PRC_ID)
    window.open(`${baseUrl}/v1/secure/user/download/baureglement?id=${this.plotItem.PRC_ID}&gemainde=${this.plotItem.PRC_MUN}&lang=${this.lang}&canton=${this.plotItem.CANTON}&ott_token=${oneTimeToken.token}`, "_blank")
  }

  async open3dElevation() {
    if (this.plotItem && this.plotItem.PRC_ID) {
      const baseUrl = config.VUE_APP_REPORTS_URL || ""
      let oneTimeToken = await searchService.getReportDownloadOneTimeToken(this.plotItem.PRC_ID)
      window.open(`${baseUrl}/v1/secure/user/download/elevation?id=${this.plotItem.PRC_ID}&ott_token=${oneTimeToken.token}`, "_blank")
    }
  }
  async openSolarPotential() {
    let lv95: any = []
    this.objectItems.forEach((item) => {
      if (item.OBJ_COO_X && item.OBJ_COO_Y) {
        lv95.push(item.OBJ_COO_X + "," + item.OBJ_COO_Y + "," + item.OBJ_ID)
      }
    })

    let urlSolarPotential = ""
    if (lv95.length > 0) {
      urlSolarPotential += "&wgs[]=" + lv95.join("&wgs[]=")
    }

    const baseUrl = config.VUE_APP_REPORTS_URL || ""
    let oneTimeToken = await searchService.getReportDownloadOneTimeToken(this.plotItem.PRC_ID)
    window.open(`${baseUrl}/v1/secure/user/download/solar?id=${this.plotItem.PRC_ID}&lang=${this.lang}&format=html${urlSolarPotential}&ott_token=${oneTimeToken.token}`, "_blank")
  }

  async fullReportPDF(plotItem) {
    console.log("fullReportPDF", plotItem)
    const baseUrl = config.VUE_APP_REPORTS_URL || ""
    let oneTimeToken = await searchService.getReportDownloadOneTimeToken(this.plotItem.PRC_ID)

    window.open(`${baseUrl}/v1/secure/user/download/full?id=${this.plotItem.PRC_ID}&lang=${this.lang}&ott_token=${oneTimeToken.token}`, "_blank")
  }

  // Basic AI-report trigger: switch to AI tab and optionally seed a prompt
  async aiReportForPlot() {
    if (this.plotItem && this.plotItem.PRC_ID) {
      let oneTimeToken = await searchService.getAIReportOneTimeToken(this.plotItem.PRC_ID)
      console.log("oneTimeToken", oneTimeToken)
      if (oneTimeToken && oneTimeToken.token) {
        let url = searchService.getUrl() + "/v1/secure/user/ai-reports/generate-ai-report-for-plot?prcid=" + this.plotItem.PRC_ID + "&lang=" + this.lang + "&ott_token=" + oneTimeToken.token
        console.log("url", url)
        window.open(url, "_blank")
      } else {
        const msg = this.$t("no-ai-report-available") as string
        utils.showSnackbarError(msg)
      }
    } else {
      const msg = this.$t("no-plot-item-selected") as string
      utils.showSnackbarError(msg)
    }
  }
}
</script>
<style>
.report-list .v-list-item__title {
  text-transform: uppercase;
}

.offset-plotreport {
  left: 738px !important;
  width: calc(100% - 738px) !important;
  position: absolute;
  padding: 0px 12px 12px 12px !important;
  border-radius: 0px;
  height: calc(100vh - 64px) !important;
  z-index: 3 !important;

  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-left: 1px solid silver;
  margin-left: 3px;
}

.offset-plotreport > .v-card {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}

.offset-plotreport .v-card-text {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* prevent double scroll on parent */
  padding-bottom: 0 !important;
}

.offset-plotreport .v-tabs-items {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.offset-plotreport .v-tabs-items .v-window__container {
  flex: 1 1 auto;
  display: flex;
}

.offset-plotreport .v-tabs-items .v-window-item {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.report-item {
  cursor: pointer;
}

/* Tabs: align left and prevent stretching */
.tabs-left .v-tabs__wrapper {
  justify-content: flex-start !important;
}

.tabs-left .v-tab {
  flex: 0 0 auto !important;
  max-width: none !important;
}

.tab-header-row {
  border-bottom: 1px solid #e0e0e0;
  min-height: 48px;
  background: #fff;
  z-index: 2;
}

.tabs-left .v-tabs {
  min-height: 40px;
}

.tabs-left .v-tab {
  min-height: 40px !important;
  align-items: center;
  display: flex;
}
</style>
